import React, { ChangeEvent, useEffect, useState } from 'react';
import { TField } from '../ui';
import {AlignmentCenterIcon, AlignmentLeftIcon, AlignmentRightIcon, InfoIcon, XIcon} from 'assests/GmsIcons';
import {
    EXCLUSION_DEFAULT,
    EXCLUSION_OPTIONS,
    MULTI_CHOICE_EXCLUDED_DEFAULT, MULTI_CHOICE_EXCLUDED_OPTIONS
} from "../../../ISRConstants";
import chipImgPreview from "../../../../../../assests/img/sb3_chip_img_preview.png";
import chipImgPreviewFullSize from "../../../../../../assests/img/sb3_chip_img_preview_full_size.jpg";
import {Tooltip} from "react-tooltip";

const EditField = ({pageLayout, field, fieldIndex, modelIndex, updateField, setEditFlag}: any) => {
    const [uifield, setUIField] = useState<TField>();

    function hideError(e: any) {
        if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
            const resizeObserverErrDiv = document.getElementById(
                'webpack-dev-server-client-overlay-div'
            );
            const resizeObserverErr = document.getElementById(
                'webpack-dev-server-client-overlay'
            );
            if (resizeObserverErr) {
                resizeObserverErr.setAttribute('style', 'display: none');
            }
            if (resizeObserverErrDiv) {
                resizeObserverErrDiv.setAttribute('style', 'display: none');
            }
        }
    }

    useEffect(() => {
        window.addEventListener('error', hideError)
        return () => {
            window.addEventListener('error', hideError)
        }
    }, [])


    const handleFieldExclusionChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const fieldExclusion = event.target.value;
        setUIField((preField) => ({
            ...preField!,
            fieldExclusion: fieldExclusion,
        }));
    }

    const handleFieldImageSizeChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const imageSize = event.target.value;
        setUIField((preField) => ({
            ...preField!,
            imageSize: imageSize,
        }));
    }

    const handleFieldImageDisplayChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const imageDisplay = event.target.value;
        setUIField((preField) => ({
            ...preField!,
            imageDisplay: imageDisplay,
        }));
    }

    const handleFieldImageCaptionAlignmentChange = (alignment: string) => {
        setUIField((preField) => ({
            ...preField!,
            captionAlignment: alignment,
        }));
    }

    const handleFieldLayoutStyleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const layoutStyle = event.target.value;
        setUIField((preField) => ({
            ...preField!,
            layoutStyle: layoutStyle,
        }));
    }

    const handleMultiChoicefieldExcludedOptionChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const fieldExclusion = event.target.value;
        setUIField((preField) => ({
            ...preField!,
            multiChoicefieldExcludedOption: fieldExclusion,
        }));
    }

    // const handleFieldInclusionChange = (event: ChangeEvent<HTMLSelectElement>) => {
    //     const fieldInclusion = event.target.value;
    //     setUIField((preField) => ({
    //         ...preField!,
    //         fieldInclusion: fieldInclusion,
    //     }));
    // }

    const handleChangeGroupLabel = (value: string) => {
        setUIField((preField) => ({
            ...preField!,
            groupLabel: value,
        }));
    }

    const handleChangeDisplayName = (value: string) => {
        setUIField((preField) => ({
            ...preField!,
            displayName: value,
        }));
    }

    const handleStyleChange = (value: string) => {
        setUIField((preField) => ({
            ...preField!,
            placement: value,
        }));
    }

    const handleLoadMoreShowAllChange = (value: boolean) => {
        setUIField((preField) => ({
            ...preField!,
            loadMoreShowAll: value,
        }));
    }

    const handleLoadMoreButtonNameChange = (value: string) => {
        setUIField((preField) => ({
            ...preField!,
            loadMoreButtonName: value,
        }));
    }

    const handleShowLessButtonNameChange = (value: string) => {
        setUIField((preField) => ({
            ...preField!,
            showLessButtonName: value,
        }));
    }

    const handleLoadMoreInitialLoadCountChange = (value: string) => {
        const changedValue = safeStringToNumber(value, 5);
        if(changedValue <= 0) {
            return;
        }
        setUIField((preField) => ({
            ...preField!,
            loadMoreInitialLoadCount: changedValue,
        }));
    }

    const handleLoadMoreShowAllRemainingChange = (value: boolean) => {
        setUIField((preField) => ({
            ...preField!,
            loadMoreShowAllRemaining: value,
        }));
    }

    const handleLoadMoreBatchCountChange = (value: string) => {
        const changedValue = safeStringToNumber(value, 5);
        if(changedValue <= 0) {
            return;
        }
        setUIField((preField) => ({
            ...preField!,
            loadMoreBatchCount: changedValue,
        }));
    }

    function safeStringToNumber(value: string | null, defaultValue: number = 0): number {
        if (value === null || value.trim() === "") return defaultValue;
        const parsed = Number(value);
        return isNaN(parsed) ? defaultValue : parsed;
    }

    useEffect (() => {
        //console.log(field)
        setUIField(field);
    }, []);

    useEffect(() => {
        if (uifield) {
            updateField(uifield, fieldIndex, modelIndex);
        }
    }, [uifield]);

    const imageSizeToolTipContent = () => {
        return <div className="tw-flex tw-gap-[17px] tw-w-[358px] tw-h-[238.90px] tw-bg-white tw-p-[16px] tw-shadow-[0px_2px_16px_0px_rgba(116,116,116,0.35)]" >
            <div className="tw-flex-1">
                <div className="tw-text-black tw-text-xs tw-font-semibold font-['Noto Sans']">Thumbnail</div>
                <div className="tw-flex tw-w-[153.33px] tw-h-[45.64px] tw-bg-white tw-border tw-border-black tw-p-[7px] tw-items-center" >
                    <img className="tw-w-[48.65px] tw-h-[31.01px]" src={chipImgPreview} />
                    <div className="tw-text-center tw-text-[#6d788c] tw-text-xs tw-ms-1">Title</div>
                </div>

            </div>
            <div className="tw-flex-1">
                <div className="tw-text-black tw-text-xs tw-font-semibold font-['Noto Sans']">Large</div>
                <div className="tw-w-[153.33px] tw-h-[182.57px] tw-bg-white tw-border tw-border-black" >
                    <img className="tw-p-[16px] tw-w-full tw-h-[119.10px]" src={chipImgPreview} />
                    <div className="tw-text-center tw-text-[#6d788c] tw-text-xs tw-ms-1">Title</div>
                </div>

            </div>
        </div>
    }

    const layoutStyleToolTipContent = () => {
        return <div className="tw-flex tw-p-[10px] tw-gap-[9px] tw-w-[246.62px] tw-h-[168.38px] tw-bg-white tw-shadow-[0px_2px_16px_0px_rgba(116,116,116,0.35)]" >
            <div className="tw-flex-1">
                <div className="tw-text-black tw-text-xs tw-font-semibold font-['Noto Sans']">Padded Frame</div>
                <div className="tw-w-[106.47px] tw-h-[126.78px] tw-bg-white tw-border tw-border-black" >
                    <img className="tw-p-[10px] tw-w-full tw-h-[82px]" src={chipImgPreview} />
                    <div className="tw-text-center tw-text-[#6d788c] tw-text-xs tw-ms-1">Title</div>
                </div>

            </div>
            <div className="tw-flex-1">
                <div className="tw-text-black tw-text-xs tw-font-semibold font-['Noto Sans']">Full Bleed Frame</div>
                <div className="tw-w-[106.47px] tw-h-[126.78px] tw-bg-white tw-border tw-border-black" >
                    <img className="tw-pb-[10px] tw-w-full tw-h-[94px]" src={chipImgPreview} />
                    <div className="tw-text-center tw-text-[#6d788c] tw-text-xs tw-ms-1">Title</div>
                </div>

            </div>
        </div>
    }

    const imageDisplayToolTipContent = () => {
        return <div className="tw-flex tw-px-[17px] tw-py-[23px] tw-gap-[9px] tw-w-[358px] tw-h-[244.42px] tw-bg-white tw-shadow-[0px_2px_16px_0px_rgba(116,116,116,0.35)]" >
            <div className="tw-flex-1">
                <div className="tw-text-black tw-text-xs tw-font-semibold font-['Noto Sans']">Fill</div>
                <div className="tw-w-[154.56px] tw-h-[184.03px] tw-bg-white tw-border tw-border-black tw-p-[17px]" >
                    <img className="tw-object-cover tw-w-full tw-h-[120.05px]" src={chipImgPreview} />
                    <div className="tw-text-center tw-text-[#6d788c] tw-text-xs tw-ms-1 tw-mt-[16px]">Title</div>
                </div>

            </div>
            <div className="tw-flex-1">
                <div className="tw-text-black tw-text-xs tw-font-semibold font-['Noto Sans']">Fit</div>
                <div className="tw-w-[154.56px] tw-h-[184.03px] tw-bg-white tw-border tw-border-black tw-p-[17px]" >
                    <img className="tw-object-center tw-object-contain tw-w-full tw-h-[120.05px] tw-bg-[#D9D9D9]" src={chipImgPreviewFullSize} />
                    <div className="tw-text-center tw-text-[#6d788c] tw-text-xs tw-ms-1 tw-mt-[16px]">Title</div>
                </div>
            </div>
        </div>
    }

    return(
        <div className="tw-w-[375px] tw-absolute tw-h-full tw-bg-white tw-shadow tw-float-right tw-right-0 tw-top-0 tw-overflow-y-scroll" style={{zIndex: 1000}}>
            <div className="tw-text-sky-950 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-leading-tight tw-my-[18px] tw-mx-[12px]">Add UI Behavior</div>
            <button className="tw-text-black tw-float-right tw-my-[-36px] tw-mx-[24px]" onClick={()=>setEditFlag(false)}>
                <XIcon />
            </button>
            <div className="tw-w-[373px] tw-h-[0px] tw-border tw-border-zinc-300"></div>

            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Exclusions</div>
            <select className="drop-down-dm tw-w-[180px] tw-py-2 tw-mx-[12px] tw-h-[36px] tw-w-[335px]" value={uifield?.fieldExclusion ?? EXCLUSION_DEFAULT} onChange={handleFieldExclusionChange} >
                {EXCLUSION_OPTIONS.map((item, index) => {
                    return (
                        <option value={item} key={item + index}>
                        {item}
                    </option>);
                })}
            </select>
            {uifield?.modelFieldType === 'Multi-choice' ? <>
                <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Excluded options</div>
                <select className="drop-down-dm tw-w-[180px] tw-py-2 tw-mx-[12px] tw-h-[36px] tw-w-[335px]"
                        value={uifield?.multiChoicefieldExcludedOption ?? MULTI_CHOICE_EXCLUDED_DEFAULT} onChange={handleMultiChoicefieldExcludedOptionChange}>
                    {MULTI_CHOICE_EXCLUDED_OPTIONS.map((item, index) => {
                        return (
                            <option value={item} key={item + index}>
                                {item}
                            </option>);
                    })}
                </select></> : null}
            {/*<div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Inclusions</div>*/}
            {/*<select className="drop-down-dm tw-w-[180px] tw-py-2 tw-mx-[12px] tw-h-[36px] tw-w-[335px]" value={uifield?.fieldInclusion ?? INCLUSION_DEFAULT} onChange={handleFieldInclusionChange} >*/}
            {/*    {INCLUSION_OPTIONS.map((item, index) => {*/}
            {/*        return (*/}
            {/*            <option value={item} key={item + index}>*/}
            {/*            {item}*/}
            {/*        </option>);*/}
            {/*    })}*/}
            {/*</select>*/}

            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Group Label</div>
            <input className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-[335px] tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none tw-mx-[12px]"
                type='text'
                value={uifield?.groupLabel}
                onChange={(e) => {
                    handleChangeGroupLabel(e.target.value)
                }}
                placeholder={'Group Label'}
            />
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Display Name</div>
            <input className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-[335px] tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none tw-mx-[12px]"
                type='text'
                value={uifield?.displayName}
                onChange={(e) => {
                    handleChangeDisplayName(e.target.value)
                }}
                placeholder={'Display Name'}
            />
            {pageLayout !== 'Guided Selling' ? <>
                <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Style</div>
                <div className="tw-flex tw-mx-4">
                    <div className="tw-flex tw-items-center tw-me-4">
                        <input checked={uifield?.placement !== "guidedSelling"} id="inline-radio" type="radio" value="" name="inline-radio-group" onChange={() => handleStyleChange("filter")} className="tw-w-4 tw-h-4 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 tw-focus:ring-blue-500 tw-dark:focus:ring-blue-600 tw-dark:ring-offset-gray-800 tw-focus:ring-2 tw-dark:bg-gray-700 tw-dark:border-gray-600"/>
                        <label htmlFor="inline-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Filter</label>
                    </div>
                    <div className="tw-flex tw-items-center tw-me-4 ">
                        <input checked={uifield?.placement === "guidedSelling"} id="inline-2-radio" type="radio" value="" name="inline-radio-group" onChange={() => handleStyleChange("guidedSelling")} className="tw-w-4 tw-h-4 tw-text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                        <label htmlFor="inline-2-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Guided Selling</label>
                    </div>
                </div>
            </> : null}
            {uifield?.fieldType === 'Chip' ? <>
                <div className="tw-text-black tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-mx-[12px] tw-mt-[24px] tw-mb-2">Chip Configuration</div>
                <div className="tw-flex-auto tw-flex tw-mt-[18px] tw-mb-2 tw-mx-[12px] tw-items-center">
                    <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-me-[5px]">Image Size</div>
                    <div className="tw-me-[5px]">
                        <div data-tooltip-id="image-size-tooltip"><InfoIcon /></div>
                        <Tooltip id="image-size-tooltip" className='tool-tip-style-custom' place='top' noArrow role='dialog'>
                            {imageSizeToolTipContent()}
                        </Tooltip>
                    </div>
                </div>
                <select id='field-image-size-select' className="drop-down-dm tw-w-[180px] tw-py-1 tw-mx-[12px] tw-h-[36px] tw-w-[335px]"
                        value={uifield?.imageSize ?? 'Thumbnail'} onChange={handleFieldImageSizeChange}>
                    {['Thumbnail', 'Large'].map((item, index) => {
                        return (
                            <option id={`field-image-size-select-option-${item}`} value={item} key={item + index}>
                                {item}
                            </option>);
                    })}
                </select></> : null}

            {uifield?.fieldType === 'Chip' ? <div className='tw-flex tw-flex-1'>
                <div className='tw-flex-1 tw-mx-[12px]'>
                    <div className="tw-flex-auto tw-flex tw-mt-[18px] tw-mb-2 tw-items-center">
                    <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-me-[5px]">Image Display</div>
                        <div className="tw-me-[5px]">
                            <div data-tooltip-id="image-display-tooltip"><InfoIcon /></div>
                            <Tooltip id="image-display-tooltip" className='tool-tip-style-custom' place='top' noArrow role='dialog'>
                                {imageDisplayToolTipContent()}
                            </Tooltip>
                        </div>
                    </div>
                    <select id='field-image-display-select' className="drop-down-dm tw-flex-1 tw-py-1 tw-h-[36px]"
                            value={uifield?.imageDisplay ?? 'Fit'} onChange={handleFieldImageDisplayChange}>
                        {['Fit', 'Fill'].map((item, index) => {
                            return (
                                <option id={`field-image-display-select-option-${item}`} value={item} key={item + index}>
                                    {item}
                                </option>);
                        })}
                    </select>
                </div>
                <div className='tw-flex-1 tw-me-[12px]'>
                    {uifield?.fieldType === 'Chip' && uifield?.imageSize === 'Large' ?
                        <>
                            <div
                                className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb -2">Caption
                                Alignment
                            </div>
                            <div
                                className={`tw-flex tw-flex-1 tw-rounded-[4px] tw-bg-[#7676801F] tw-p-[4px] tw-me-[12px]`}>
                                {['left', 'center', 'right'].map((alignment) => {
                                    const captionAlignment = uifield?.captionAlignment ?? 'left';
                                    return <button
                                        key={alignment}
                                        id={`button-caption-alignment-${alignment}`}
                                        className={`tw-flex-grow tw-py-1 tw-text-[13px] tw-px-4 sm:tw-px-3.5 sm:tw-w-auto tw-max-w-[120px] tw-overflow-hidden tw-whitespace-nowrap ${captionAlignment === alignment
                                            ? 'tw-rounded-[4px] tw-py-1.5 tw-font-semibold tw-bg-white tw-text-blue-800 tw-shadow tw-border tw-border-black tw-border-opacity-5 tw-flex tw-items-center tw-justify-center   transition duration-300 ease-in-out'
                                            : 'tw-flex tw-font-normal tw-items-center tw-justify-center transition duration-300 ease-in-out'} tw-rounded tw-h-[32px]`}
                                        onClick={() => handleFieldImageCaptionAlignmentChange(alignment)}
                                    >
                                        <span id={`image-large-alignment-btn-text-11`}>
                                            {alignment === 'center' ? <AlignmentCenterIcon
                                                isSelected={captionAlignment === 'center'}/> : alignment === 'right' ?
                                                <AlignmentRightIcon isSelected={captionAlignment === 'right'}/> :
                                                <AlignmentLeftIcon isSelected={captionAlignment === 'left'}/>}
                                        </span>
                                    </button>;
                                })}
                            </div>
                        </>
                    : null}
                </div>
            </div> : null}

            {uifield?.fieldType === 'Chip' && uifield?.imageSize === 'Large' ? <>
                <div className="tw-flex-auto tw-flex tw-mt-[18px] tw-mb-2 tw-mx-[12px] tw-items-center">
                    <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-me-[5px]">Layout Style</div>
                    <div className="tw-me-[5px]">
                        <div data-tooltip-id="layout-style-tooltip"><InfoIcon /></div>
                        <Tooltip id="layout-style-tooltip" className='tool-tip-style-custom' place='top' noArrow role='dialog'>
                            {layoutStyleToolTipContent()}
                        </Tooltip>
                    </div>
                </div>
                <select id= 'field-layout-style-select' className="drop-down-dm tw-flex-1 tw-py-1 tw-h-[36px] tw-mx-[12px] tw-w-[46%]"
                        value={uifield?.layoutStyle ?? 'Padded Frame'} onChange={handleFieldLayoutStyleChange}>
                    {['Padded Frame', 'Full Bleed Frame'].map((item, index) => {
                        return (
                            <option id={`field-layout-style-select-option-${item}`}value={item} key={item + index}>
                                {item}
                            </option>);
                    })}
                </select></> : null}

            {uifield?.fieldType !== 'Drop down' ? <>

            </> : null}
            {uifield?.fieldType !== 'Drop down' ? <>
                <div className="tw-flex tw-mx-4 tw-mt-[24px]">
                    <div className="tw-flex tw-items-center tw-me-4">
                        <input checked={uifield?.loadMoreShowAll !== false} id="inline-radio-show-all" type="radio" value="" name="inline-radio-group-show-all" onChange={() => handleLoadMoreShowAllChange(true)} className="tw-w-4 tw-h-4 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 tw-focus:ring-blue-500 tw-dark:focus:ring-blue-600 tw-dark:ring-offset-gray-800 tw-focus:ring-2 tw-dark:bg-gray-700 tw-dark:border-gray-600"/>
                        <label htmlFor="inline-radio-show-all" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Show all</label>
                    </div>
                    <div className="tw-flex tw-items-center tw-me-4 ">
                        <input checked={uifield?.loadMoreShowAll === false} id="inline-radio-show-all-2" type="radio" value="" name="inline-radio-group-show-all" onChange={() => handleLoadMoreShowAllChange(false)} className="tw-w-4 tw-h-4 tw-text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                        <label htmlFor="inline-radio-show-all-2" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Show partial</label>
                    </div>
                </div>
                {uifield?.loadMoreShowAll === false ? <>
                <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Initial load count</div>
                <input className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-[335px] tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none tw-mx-[12px]"
                    type='number'
                    value={uifield?.loadMoreInitialLoadCount ?? 5}
                    onChange={(e) => {
                        handleLoadMoreInitialLoadCountChange(e.target.value)
                    }}
                    placeholder={'Initial load count'}
                />
                <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Name of the button</div>
                <input className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-[335px] tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none tw-mx-[12px]"
                    type='text'
                    value={uifield?.loadMoreButtonName ?? 'Show more'}
                    onChange={(e) => {
                        handleLoadMoreButtonNameChange(e.target.value)
                    }}
                    placeholder={'Name of the button'}
                />
                <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Name of show less button</div>
                <input className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-[335px] tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none tw-mx-[12px]"
                    type='text'
                    value={uifield?.showLessButtonName ?? 'Show less'}
                    onChange={(e) => {
                        handleShowLessButtonNameChange(e.target.value)
                    }}
                    placeholder={'Name of show less button'}
                />
                <div className="tw-flex tw-mx-4 tw-mt-[18px]">
                    <div className="tw-flex tw-items-center tw-me-4">
                        <input checked={uifield?.loadMoreShowAllRemaining !== false} id="inline-radio-show-all-remaining" type="radio" value="" name="inline-radio-group-show-all-remaining" onChange={() => handleLoadMoreShowAllRemainingChange(true)} className="tw-w-4 tw-h-4 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 tw-focus:ring-blue-500 tw-dark:focus:ring-blue-600 tw-dark:ring-offset-gray-800 tw-focus:ring-2 tw-dark:bg-gray-700 tw-dark:border-gray-600"/>
                        <label htmlFor="inline-radio-show-all-remaining" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Show all remaining</label>
                    </div>
                    <div className="tw-flex tw-items-center tw-me-4 ">
                        <input checked={uifield?.loadMoreShowAllRemaining === false} id="inline-radio-show-all-remaining-2" type="radio" value="" name="inline-radio-group-show-all-remaining" onChange={() => handleLoadMoreShowAllRemainingChange(false)} className="tw-w-4 tw-h-4 tw-text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                        <label htmlFor="inline-radio-show-all-remaining-2" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Batch of </label>
                        <input className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-[50px] tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none tw-mx-[12px]"
                    type='number'
                    value={uifield?.loadMoreBatchCount ?? '5'}
                    onChange={(e) => {
                        handleLoadMoreBatchCountChange(e.target.value)
                    }}
                    placeholder={'Name of the button'}
                />
                    </div>
                </div>
                </> : null}
            </> : null}

            {/*{uifield?.fieldType === 'Radio Button' ?*/}
            {/*    <>*/}
            {/*        <div className="tw-text-black tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-mx-[12px] tw-mt-[24px] tw-mb-3">Radio Button Configuration</div>*/}
            {/*        <div className='tw-flex tw-flex-1'>*/}
            {/*            <div className='tw-flex-1 tw-mx-[12px]'>*/}
            {/*                <div className="tw-flex-auto tw-flex tw-mb-2 tw-items-center">*/}
            {/*                    <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-me-[5px]">Column*/}
            {/*                        Selection*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <select id='field-image-display-select'*/}
            {/*                        className="drop-down-dm tw-flex-1 tw-py-1 tw-h-[36px]"*/}
            {/*                        value={'Auto'} onChange={handleFieldImageDisplayChange}>*/}
            {/*                    {['Auto', '1', '2', '3', '4', '5', '6'].map((item, index) => {*/}
            {/*                        return (*/}
            {/*                            <option id={`field-image-display-select-option-${item}`} value={item}*/}
            {/*                                    key={item + index}>*/}
            {/*                                {item}*/}
            {/*                            </option>);*/}
            {/*                    })}*/}
            {/*                </select>*/}
            {/*            </div>*/}
            {/*            <div className='tw-flex-1 tw-mx-[12px]'>*/}
            {/*                <div className="tw-flex-auto tw-flex tw-mb-2 tw-items-center">*/}
            {/*                    <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-me-[5px]">Fill*/}
            {/*                        Direction*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <select id='field-image-display-select'*/}
            {/*                        className="drop-down-dm tw-flex-1 tw-py-1 tw-h-[36px]"*/}
            {/*                        value={uifield?.imageDisplay ?? 'Fit'} onChange={handleFieldImageDisplayChange}>*/}
            {/*                    {['Vertical', 'Horizontal'].map((item, index) => {*/}
            {/*                        return (*/}
            {/*                            <option id={`field-image-display-select-option-${item}`} value={item}*/}
            {/*                                    key={item + index}>*/}
            {/*                                {item}*/}
            {/*                            </option>);*/}
            {/*                    })}*/}
            {/*                </select>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </> : null}*/}

            <button onClick={() => setEditFlag(false)} className="small-filled-btn tw-px-[24px] tw-h-[30px] tw-mx-[12px] tw-mt-[18px] tw-mb-[38px]">Done</button>
        </div>
    );
}

export default EditField;